// @flow
import type { $Request } from 'express';
import type { UtmParams } from '@rover/react-lib/types';
import appendUrlParams from '@rover/utilities/appendUrlParams';

export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export const getUtmParamsFromRequest = (req: $Request): UtmParams =>
  Object.keys(req.query)
    .filter(key => UTM_PARAMS.includes(key))
    .reduce((params, key) => ({ ...params, [key]: req.query[key] }), {});

export const addUtmParamsToUrl = (utmParams: UtmParams, url: string) => {
  if (!utmParams || !utmParams.utm_source || !utmParams.utm_source.length) return url; // utm_source is required: https://ga-dev-tools.appspot.com/campaign-url-builder/
  return appendUrlParams(url, utmParams);
};



// WEBPACK FOOTER //
// ../utilities/utm.js